<template>
  <LoadingWithText v-if="isLoading" />
  <div v-else>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <PageHeader class="text-lg font-medium mr-auto" />
      <!-- <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <a class="button text-white bg-theme-1 shadow-md">
          {{ $t('text.create') }}
        </a>
      </div> -->
    </div>
    <div class="intro-y grid grid-cols-12 gap-6 mt-5">
      <div
        v-for="(officer, index) in officerList"
        :key="index"
        class="intro-y col-span-12 md:col-span-6"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center p-5">
            <div class="w-24 h-24 lg:w-12 lg:h-12 flex-none image-fit relative lg:mr-1">
              <div
                class="flex items-center justify-center w-24 h-24 lg:w-12 lg:h-12 bg-gray-200 dark:bg-dark-5 rounded-full"
              >
                <UserIcon class="w-8 h-8 lg:h-5 lg:w-5" />
              </div>
            </div>
            <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
              <a href="" class="font-medium">{{ officer | fullName }}</a>
              <div class="text-gray-600 text-xs">{{ officer.phone }}</div>
            </div>
            <div class="mt-4 lg:mt-0">
              <Button
                :to="{ name: 'OfficerDetails', params: { officerId: officer.id } }"
                class="button--sm text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300"
              >
                {{ $t('text.seeMore') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { OFFICER_LIST_REQUEST, OFFICER_REMOVE } from '@/store/actions/officer';
import PageHeader from '@/components/ui/PageHeader';
import Button from '@/components/ui/button/Button';

export default {
  components: {
    PageHeader,
    Button,
  },

  computed: {
    ...mapGetters(['officerList', 'officerMeta', 'officerStatus']),
    isLoading() {
      return this.officerStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    confirmRemoval(id) {
      this.officerIdToRemove = id;
      cash(`#${this.deleteModalId}`).modal('show');
    },

    async onDelete() {
      cash(`#${this.deleteModalId}`).modal('hide');
      try {
        const payload = {
          businessId: this.business.id,
          id: this.officerIdToRemove,
        };
        await this.$store.dispatch(OFFICER_REMOVE, payload);
      } catch (error) {
        this.$toasted.show(error.message, { type: 'error' });
      }
      this.officerIdToRemove = null;
    },

    async fetchData() {
      await this.$store.dispatch(OFFICER_LIST_REQUEST);
    },
  },
};
</script>
